import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeProviders = data => {
  const provider = new schema.Entity('providers')
  return normalize(data, [provider])
}

const ProvidersReducer = combineReducers({
  connectProviderRequest: createRequestReducer('PROVIDERS:CONNECT'),
  removeProviderRequest: createRequestReducer('PROVIDERS:REMOVE'),
  providers: createReducer(null, {
    'PROVIDERS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeProviders(response.data.account.oauth_identities),
    'PROVIDERS:REMOVE_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      result: state.result.filter(id => id !== params.id)
    }),
    'PROVIDERS:CONNECT_REQUEST_SUCCESS': (state, { response }) =>
      response && response.data
        ? normalizeProviders(response.data.account.oauth_identities)
        : state
  })
})

export default ProvidersReducer
